import React from 'react';

import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import FilterListIcon from '@material-ui/icons/FilterList';
import Grid from '@material-ui/core/Grid';

import FilterDialog from '../filterdialog';

export default function FilterLogDialog({ children, ...props }) {

  const [openFilter, setOpenFilter] = React.useState(false);

  function handleFilterClick(event) {
    event.preventDefault();
    setOpenFilter(true);
  }

  function onClearFilterClick(event) {
    event.preventDefault();
    if (props.setFilter) {
      props.setFilter(null);
    }
  }

  return (
    <Grid
      alignItems='center'
      container={true}
      spacing={1}
    >
      <Grid
        item={true}
      >
        <FilterDialog
          title={props.title}
          open={openFilter}
          setOpen={setOpenFilter}
          filter={props.filter}
          setFilter={props.setFilter}
          show_to_account={props.show_to_account || false}
          show_from_account={props.show_from_account || false}
          show_owner_email={props.show_owner_email || false}
          show_owner_name={props.show_owner_name || false}
        />
      </Grid>
      <Grid
        item={true}
      >
        <Fab
          aria-label='filter'
          color={props.filter ? 'secondary' : 'primary'}
          onClick={handleFilterClick}
        >
          <FilterListIcon />
        </Fab>
      </Grid>
      <Grid
        item={true}
      >
        {props.filter &&
          <Button
            color='primary'
            variant='contained'
            onClick={onClearFilterClick}
          >
            {'Limpar filtro'}
          </Button>
        }
      </Grid>
    </Grid>
  );
}
